import React, {Component} from 'react';
import {QuestionCategory} from "../../../../../wpconfig";
import * as func from "../../../../../utils/functions";

class MPIds extends Component {
	constructor(props) {
		super(props);

		this.state = {
			activeTab: '',
			field : 'question',
			status : false,
		}

		this.onSave = this.onSave.bind(this);
	}

	closePopup = () => {
		this.props.closePopup('isShowEditIds')
	}

	onSave = (event) => {
		event.preventDefault()

		if (this.content.value === '') {
			this.content.focus();
		} else {
			const p = {
				'content' : this.content.value,
				'category' : QuestionCategory.MY_ID,
			}
			// delete record.is_edit;
			func.updateData(this.state.field + "/insert", p).then((response) => {
				console.log(response)
				if (response.code === 'ok') {
					this.setState({status : true});
				} else {
					alert('전산팀에 문의해주세요.')
				}
			});
		}
	};

	render() {
		const record = this.props.record;
		console.log(record)
		return (
			<div className="modal show" id="idModify" tabIndex="-1">
				<div className="modal-dialog modal-smd modal-dialog-centered">
					{!this.state.status ?
						<div className="modal-content">
							<div className="modal-header pb-5">
								<h3 className="con-title">연구자 ID 수정요청</h3>
							</div>
							<div className="modal-body">
								<div className="row">
									<div className="col-sm-6">
										<h6>등록된 리스트</h6>
										<div className="user-profile-list">
											{record.school_no ?
												<div className="list-cell"><strong>교직원번호(대표)</strong>
													<div className="txt">{record.school_no}</div>
												</div>
												: ''
											}
											{record.orcid ?
												<div className="list-cell"><strong>ORCID</strong>
													<div className="txt">{record.orcid}</div>
												</div>
												: ''
											}
											{record.researchgate_id ?
												<div className="list-cell"><strong>ResearchGate ID</strong>
													<div className="txt">{record.researchgate_id}</div>
												</div>
												: ''
											}
											{record.scopus_id ?
												<div className="list-cell"><strong>Scopus ID</strong>
													<div className="txt">{record.scopus_id}</div>
												</div>
												: ''
											}
											{record.researcher_id ?
												<div className="list-cell"><strong>Researcher ID</strong>
													<div className="txt">{record.researcher_id}</div>
												</div>
												: ''
											}
											{record.kci_id ?
												<div className="list-cell"><strong>KCI ID</strong>
													<div className="txt">{record.kci_id}</div>
												</div>
												: ''
											}
											{record.googlescholar_id ?
												<div className="list-cell"><strong>GoogleScholar ID</strong>
													<div className="txt">{record.googlescholar_id}</div>
												</div>
												: ''
											}
											{record.isni ?
												<div className="list-cell"><strong>ISNI</strong>
													<div className="txt">{record.isni}</div>
												</div>
												: ''
											}
											{record.research_ids.map((item, index) => {
												return (
													<div key={index} className="list-cell"><strong>{item.label}</strong>
														<div className="txt">{item.id_value}</div>
													</div>
												)
											})}
										</div>
									</div>
									<div className="col-sm-6">
										<h6>연구자 ID 생성 바로가기</h6>
										<div className="user-profile-list">
											<div className="list-cell"><strong>ORCID</strong>
												<div className="txt"><a href="https://orcid.org" target="_blank">https://orcid.org</a></div>
											</div>
											<div className="list-cell"><strong>ResearchGate ID</strong>
												<div className="txt"><a href="https://www.researchgate.net" target="_blank">https://www.researchgate.net</a></div>
											</div>
											<div className="list-cell"><strong>Scopus ID</strong>
												<div className="txt"><a href="https://www.scopus.com" target="_blank">https://www.scopus.com</a></div>
											</div>
											<div className="list-cell"><strong>Researcher ID(WoS)</strong>
												<div className="txt"><a href="https://www.webofscience.com/wos/woscc/basic-search" target="_blank">www.webofscience.com</a></div>
											</div>
											<div className="list-cell text-success mt-3"><strong>연구자 ID 생성 매뉴얼</strong>
												<div className="txt"><a href="https://lib.pusan.ac.kr/scholar/wp-content/uploads/sites/4/2024/10/ID_Guide.pdf" target="_blank" className="btn btn-sm btn-outline-danger p-0 pl-1 pr-1">다운로드</a></div>
											</div>
										</div>
									</div>
								</div>

								<div className="mt-4 pt-px-26 border-top border-lightgray">
									<div className="mt-px-10">
									<textarea
										className="form-control lg"
										name="content"
										ref={(ref) => this.content = ref}
										placeholder="연구자 ID 추가/수정하려는 정보를 입력해주세요."
										defaultValue="아래의 아이디를 생성하신 후 입력해 주세요. 아이디별 생성 사이트는 위의 바로가기를 참고하세요.
위 등록된 리스트에 해당 아이디가 있다면 생성하지 않아도 됩니다.
_____________________________________________
ORCID :
ResearchGate ID :
Scopus ID :
Researcher ID(WoS) :
_____________________________________________
등록된 아이디 중 수정이 필요할 경우 아래에 적어 주세요."
									/>
									</div>
									<div className="mt-2">
										<div className="d-flex align-items-center font-size-14 color-lightblack">
											<span className="flex-auto icon icon-size-24 icon-warning-black mr-1"/>
											등재 아이디 수정요청은 담당자의 확인을 거쳐 반영되며 요청하신 결과는 1:1 문의에서 확인하실 수 있습니다.
										</div>
									</div>
								</div>
							</div>
							<div className="modal-footer mt-3">
								<button type="button" className="btn btn-outline-gray" onClick={this.closePopup}><strong>취소</strong></button>
								<button type="button" className="btn btn-darkblue" onClick={this.onSave}><strong>수정요청</strong></button>
							</div>
							<button type="button" className="btn-close" onClick={this.closePopup}/>
						</div>
						:
						<div className="modal-content pl-3 pr-3">
							<div className="modal-body">
								<div className="msg-desc">등재아이디 수정신청이 접수되었습니다.<br/>신청진행은 1:1 문의에서 확인하실 수 있습니다.</div>
							</div>
							<div className="modal-footer">
								<button type="button" className="btn btn-darkblue" onClick={this.closePopup}><strong>확인</strong></button>
							</div>
							<button type="button" className="btn-close" onClick={this.closePopup}/>
						</div>
					}
				</div>
			</div>
		)
	}
};

export default MPIds;
